import { render } from "./PromoPreview.vue?vue&type=template&id=3d365d24&scoped=true"
import script from "./PromoPreview.vue?vue&type=script&lang=js"
export * from "./PromoPreview.vue?vue&type=script&lang=js"

import "./PromoPreview.vue?vue&type=style&index=0&id=3d365d24&lang=scss&scoped=true"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d365d24"]])

export default __exports__